import CustomSelect from '@/fsd/shared/ui/CustomSelect/CustomSelect';
import { observer } from 'mobx-react-lite';
import { HTMLAttributes, useMemo } from 'react';
import { OPTIONS } from './consts';
import styles from './PageSizeSelect.module.scss';
import { IPageSizeSelectOption } from './types';

interface CustomSelectOption {
  id: string | number;
  name: string;
  value: string;
}

interface IProps extends HTMLAttributes<HTMLDivElement> {
  openDirection?: 'top' | 'bottom' | 'right' | 'left';
  onOptionChange: (option: IPageSizeSelectOption) => void;
  value: string;
  options?: IPageSizeSelectOption[];
  placeholder?: string;
}

const PageSizeSelect = observer(
  ({
    value,
    openDirection,
    onOptionChange,
    options = OPTIONS,
    placeholder,
    ...props
  }: IProps) => {
    const adaptedOptions = useMemo(
      () =>
        options.map((opt) => ({
          id: opt.value,
          name: opt.name,
          value: String(opt.value),
        })),
      [options]
    );

    const handleSelectChange = (selectedOption: CustomSelectOption) => {
      const originalOption = options.find(
        (opt) => String(opt.value) === selectedOption.value
      );
      if (originalOption) {
        onOptionChange(originalOption);
      }
    };

    return (
      <CustomSelect
        options={adaptedOptions}
        value={value}
        onOptionChange={handleSelectChange}
        openDirection={openDirection}
        className={styles.select}
        placeholder={placeholder}
        usePortal={false}
        {...props}
      />
    );
  }
);

export default PageSizeSelect;
